import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

/**
 * KPI Cell component for displaying KPI values with appropriate color coding
 */
const KpiCell = ({ value, color, bgColor, label, tooltip }) => {
  return (
    <div className="px-4 py-4 whitespace-nowrap text-sm">
      <div className="flex justify-center">
        <span
          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${color} ${bgColor}`}
          title={tooltip || ""}
        >
          {label || (value !== null ? `${value} días` : "-")}
          {tooltip && (
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1 text-gray-500"
            />
          )}
        </span>
      </div>
    </div>
  );
};

KpiCell.propTypes = {
  value: PropTypes.number,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string,
};

KpiCell.defaultProps = {
  color: "text-gray-500",
  bgColor: "bg-gray-100",
  value: null,
  label: "-",
  tooltip: "",
};

export default KpiCell;
